import { Component, ElementRef, inject, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import icons from './icons.json';
import { SvgIcons } from './svg-icon';

@Component({
    selector: 'lib-svg-icon',
    templateUrl: './svg-icon.component.html',
    styleUrls: ['./svg-icon.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SvgIconComponent implements OnInit {
    private readonly sanitizer = inject(DomSanitizer);

    @ViewChild('iconParentEl') iconParentEl!: ElementRef;

    @Input({ required: true }) icon!: SvgIcons;
    @Input() set active(value: boolean) {
        this.isActive = value;
        this.handleSvg();
    }
    @Input() set color(value: string) {
        this._color = value;
        this.handleSvg();
    }
    @Input() activeColor?: string;
    @Input() hoverColor?: string;

    svg: SafeHtml = '';
    rotate45 = false;

    private isActive = false;
    private _color = '';
    private isHovered = false;

    ngOnInit() {
        this.handleSvg();
    }

    mouseEntered(): void {
        this.isHovered = true;
        this.processHover();
    }

    mouserLeaved(): void {
        this.isHovered = false;
        this.processHover();
    }

    private setSvg(color: string) {
        if (this.icon === SvgIcons.CLOSE) {
            this.rotate45 = true;
        }

        this.svg = this.sanitizer.bypassSecurityTrustHtml(this.updateSvg(icons[this.icon], color));
    }

    private handleSvg(): void {
        const color = this.isActive
            ? this.activeColor || 'var(--common-icon-active-color)'
            : this._color || 'var(--mdc-text-button-disabled-label-text-color)';

        this.setSvg(color);
    }

    private updateSvg(svgString: string, color: string): string {
        const parser = new DOMParser();
        const serializer = new XMLSerializer();
        const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
        const paths = svgDoc.getElementsByTagName('path');

        for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            if (path.hasAttribute('fill')) {
                path.setAttribute('fill', color);
            }
            if (path.hasAttribute('stroke')) {
                path.setAttribute('stroke', color);
            }
        }

        return serializer.serializeToString(svgDoc);
    }

    private processHover(): void {
        if (this.isHovered && this.hoverColor && !this.activeColor) {
            this.setSvg(this.hoverColor);

            return;
        }

        this.handleSvg();
    }
}
